function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-elecInterrupteur");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-elecInterrupteur"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(8.000000, 10.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 14,
  height: 11
})), /*#__PURE__*/React.createElement("path", {
  d: "M22,8 L22,22 L8,22 L8,8 L22,8 Z M19,11 L11,11 L11,19 L19,19 L19,11 Z M18,12 L18,18 L12,18 L12,12 L18,12 Z",
  id: "Combined-Shape-Copy-3",
  fill: "#D93252"
})));

const SvgIco30ElecInterrupteur = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ElecInterrupteur, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-elecInterrupteur.65a085dc.svg";
export { ForwardRef as ReactComponent };